import React, { useState } from 'react';
import { Card } from '@mui/material';
import { TraxxInput, TraxxButton, VisibilityAdornment } from '../../components';
import { makeStyles } from '@mui/styles';
import { API } from '../../services';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';

const GlobalRegex = {
  EmailValidation:
    // eslint-disable-next-line no-control-regex
    /(?!.*\.{2})^([a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i
};

const init_input = {
  password: '',
  email: ''
};

const login_input_list = ['password', 'email'];

const init_errors = {
  password: ' ',
  email: ' '
};

const useStyles = makeStyles(({ palette }) => ({
  content: {
    display: 'flex',
    minHeight: 'calc(100vh-69px)',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    direction: 'column',
    paddingTop: 20
  },
  card: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: 260,
    justifyContent: 'space-around',
    padding: '48px 40px 22px',
    width: 410
  },
  button: {
    paddingTop: 10
  }
}));

const Login = () => {
  const classes = useStyles();
  const [inputs, setInputs] = useState(init_input);
  const [errors, setErrors] = useState(init_errors);
  const [visibility, setVisibility] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  /**
   * Callback function when text inputs are changed
   *
   * @param {string} type - corresponding input type that is to be updated
   */
  const handleChange = (type) => {
    return ({ target }) => setInputs({ ...inputs, [type]: target.value });
  };

  /**
   * Toggle visibility of the password input
   *
   * @param {bool} value - whether password input shoul be visible or not
   */
  const handleClick = (value) => {
    setVisibility((value) => !value);
  };

  /**
   * verify all input fields are filled in and valid email address format is provided
   *
   * @return {bool} - return true if all inputs are validated
   */
  const validateInput = () => {
    let exit = true;
    const { password, email } = inputs;
    const error = {
      email: ' ',
      password: ' '
    };
    if (!email) error.email = 'Input is required';
    if (!password || password.length < 8) error.password = 'Minimum 8 characters';
    if ((email !== '') & !GlobalRegex.EmailValidation.test(email)) {
      error.email = 'Invalid email format';
    }
    setErrors(error);
    for (var name in login_input_list) {
      if (error[login_input_list[name]] !== ' ') {
        exit = false;
      }
    }
    // console.log('inputs validated: ' + exit);
    return exit;
  };

  /**
   * Callback function when user presses submit button
   *
   * Validate inputs and calls login API for authentication
   * If any of the user's accounts are related to TRAXX,
   *    1 save user's email and access token in local storage
   *    2 navigate to /statusViewer/applications page for view application details
   */
  const onSubmit = async () => {
    if (validateInput()) {
      try {
        const { access, self, accounts } = await API.Authentication.login({ username: inputs.email, password: inputs.password });
        const tkn = access.token;
        const email = self.person.primary_email;
        var valid = false;

        // -- check validity of accounts -- //
        accounts.forEach((element) => {
          if (element.name.toLowerCase().includes('traxx')) {
            valid = true;
          }
        });
        if (valid) {
          localStorage.setItem('user_email', email);
          localStorage.setItem('access_token', tkn);
          // await API.Compliance.get_countries(tkn).then((cty) => {
          //   const map = Object.keys(cty.countries)
          //     .map((country) => ({ code: country, name: cty.countries[country], value: country }))
          //     .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
          //   countries.list = map;
          //   console.log('Login success');
          // });
          navigate(`/statusViewer/applications`);
        } else {
          // console.log('Login failure');
          enqueueSnackbar(`Invalid Login Credentials!`, {
            variant: 'warning',
            autoHideDuration: 3000
          });
          inputs.email = '';
          inputs.password = '';
        }
      } catch (error) {
        console.log('Error: ' + error);
        enqueueSnackbar('Server Error', {
          variant: 'warning',
          autoHideDuration: 3000
        });
      }
    }
  };
  return (
    <div className={classes.content}>
      <h3>Login</h3>
      <sub>Please use your traxx.id credential for login</sub>
      <br />
      <Card className={classes.card}>
        <TraxxInput
          label="Email"
          input={inputs.email}
          placeholder=""
          error={errors.email}
          required={true}
          value={inputs.email}
          onChange={handleChange('email')}
          id="Email"
          onKeyPress={(ev) => {
            if (ev.key === 'Enter') onSubmit(ev);
          }}
        />
        <TraxxInput
          label="Password"
          input={inputs.password}
          placeholder="Minimum 8 characters"
          error={errors.password}
          required={true}
          value={inputs.password}
          onChange={handleChange('password')}
          id="Password"
          onKeyPress={(ev) => {
            if (ev.key === 'Enter') onSubmit(ev);
          }}
          type={visibility ? 'text' : 'password'}
          InputProps={{ endAdornment: <VisibilityAdornment onClick={handleClick} /> }}
        />
        <TraxxButton onSubmit={onSubmit} className={classes.button}>
          Submit
        </TraxxButton>
      </Card>
    </div>
  );
};

export default Login;
